
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import type Vue from 'vue'
import type { ExplainMessages } from '../../../models/i18n/explain.messages'
import {
  PinProductAction,
  QueryRankingElementRankingAction,
} from '@empathyco/playboard-core-domain'
import { defineComponent, getCurrentInstance } from 'vue'
import { useQueryRankingElementActionsConfig } from '../../../composables/use-query-ranking-element-actions-config'
import { ColorEnum } from '../../../enums'
import { ExplainUtils } from '../../../utils/explain.utils'
import { EpbBadge } from '../../shared/epb-badge'
import { EpbText } from '../../shared/epb-text'

export default defineComponent({
  name: 'TotalScore',
  components: {
    EpbText,
    EpbBadge,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }
    const explainMessages = $epb.messages.explain as ExplainMessages
    const queryRankingAction = ExplainUtils.getQueryRankingConfigActionFromResult(props.result)
    const queryRankingActionConfig = queryRankingAction
      ? useQueryRankingElementActionsConfig().getActionConfig(queryRankingAction)
      : undefined
    const score = ExplainUtils.getScoreCriteriaValue(props.result).toLocaleString($epb.locale, {
      maximumFractionDigits: 6,
    })

    let backgroundColor = ColorEnum.NEUTRAL_10
    let text = `${explainMessages.productAnalysis.totalScore}: ${score}`
    switch (queryRankingAction) {
      case PinProductAction:
        backgroundColor = ColorEnum.NEUTRAL_95
        text = `${queryRankingActionConfig.labelPast} | ${explainMessages.productAnalysis.noScore}`
        break
      case QueryRankingElementRankingAction.BOOST:
      case QueryRankingElementRankingAction.BURY:
        backgroundColor = ColorEnum.NEUTRAL_95
        text = `${queryRankingActionConfig.labelPast} | ${explainMessages.productAnalysis.totalScore}: ${score}`
        break
    }

    return {
      baseClass: 'epb-total-score',
      text,
      backgroundColor,
      queryRankingActionConfig,
    }
  },
})
